/**
 * Init filter
 */
export function initFilter() {
	const form = document.querySelector('.section-filter form');

	if (!form) {
		return;
	}

	const source = form.querySelector('[name="source"]');

	form.addEventListener('change', (e) => {
		// Uncheck all items if value is equal to reset, except the 'reset' item itself.
		if ('jargon' === source.value) {
			if ('reset' === e.target.value) {
				form.querySelectorAll('input[type=checkbox]').forEach(
					(el) => (el.checked = false)
				);

				e.target.checked = true;
			} else {
				form.querySelector('input[value="reset"]').checked = false;

				// Check 'reset' item if no filters are selected.
				if (0 === form.querySelectorAll('input[type=checkbox]:checked').length) {
					form.querySelector('input[value="reset"]').checked = true;
				}
			}
		}

		loadPosts('filter');
	});
}

/**
 * Init load more
 */
export function initLoadMore() {
	const button = document.querySelector('.load-more');

	if (!button) {
		return;
	}

	button.addEventListener('click', (e) => {
		loadPosts('more');
	});
}

/**
 * Load posts
 */
function loadPosts(method) {
	const form = document.querySelector('.section-filter form');
	const wrapper = document.querySelector('.section-ajax .ajax-posts');
	const offset = document.querySelector('.section-filter form [name="offset"]');
	const button = document.querySelector('.section-ajax .continue');
	const xhrFormData = new FormData(form);

	// Add class to indicate loading.
	if ('filter' === method) {
		wrapper.classList.add('loading');
	}

	// Prepare XHR data.
	xhrFormData.append('action', 'wettermerk_ajax_load_posts');
	xhrFormData.append('nonce', wettermerk_xhr.nonce);
	xhrFormData.append('method', method);

	fetch(wettermerk_xhr.ajaxurl, {
		method: 'POST',
		body: xhrFormData,
		cache: 'default',
	})
		.then((response) => response.json())
		.then((data) => {
			if ('more' === method) {
				wrapper.insertAdjacentHTML('beforeend', data.html);
			} else {
				wrapper.innerHTML = data.html;
			}

			// Update offset.
			if ('more' === method) {
				offset.value = parseInt(offset.value) + parseInt(data.count);
			}

			// Hide button if all posts are loaded.
			if (button && data.finished === true) {
				button.style.display = 'none';
			}
		})
		.catch((error) => {
			// eslint-disable-next-line no-console
			console.error(error);
		})
		.finally(() => {
			if ('filter' === method) {
				wrapper.classList.remove('loading');
			}
		});
}
